module.exports = __webpack_public_path__ + "img/srna-monthly.648fb2f6.png";